import { useSelector } from 'react-redux';
import { selectSaveAndCloseCompleted, selectSaveCompleted } from '../assessmentsSlice';
import { useAssessmentsQuestions } from './useAssessmentsQuestions';
import { useAssessmentsLoadAnswers } from './useAssessmentsLoadAnswers';
import { useLoadAssessmentRetry } from './useLoadAssessmentRetry';

export const useLoadAssessments = () => {
  const saveCompleted = useSelector(selectSaveCompleted);
  const saveAndCloseCompleted = useSelector(selectSaveAndCloseCompleted);
  const { loading, error: assessmentsQuestionsError } = useAssessmentsQuestions();
  const { assessmentsAnswersError, assessmentsAnswersLoading } = useAssessmentsLoadAnswers();
  const { retryLoadAssessments } = useLoadAssessmentRetry();

  return {
    loading: loading || assessmentsAnswersLoading,
    error: assessmentsQuestionsError || assessmentsAnswersError,
    saveCompleted,
    saveAndCloseCompleted,
    retryLoadAssessments,
  };
};
